import {
    MACHINE_WISE_BEAM_STOCK_REPORT_REQUEST,
    MACHINE_WISE_BEAM_STOCK_REPORT_SUCCESS,
    MACHINE_WISE_BEAM_STOCK_REPORT_FAILURE,
    MACHINE_WISE_BEAM_STOCK_FILTER_REPORT_REQUEST,
    MACHINE_WISE_BEAM_STOCK_FILTER_REPORT_SUCCESS,
    MACHINE_WISE_BEAM_STOCK_FILTER_REPORT_FAILURE,
  } from "../types";
  
  const initialState = {
    machineWiseBeamStockReport: {},
    machineWiseBeamStockFilterOptions: {},
    loading: false,
    error: null,
  };
  
  const machineWiseBeamStockReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case MACHINE_WISE_BEAM_STOCK_REPORT_REQUEST, MACHINE_WISE_BEAM_STOCK_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case MACHINE_WISE_BEAM_STOCK_REPORT_SUCCESS: {
        return {
          ...state,
          machineWiseBeamStockReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case MACHINE_WISE_BEAM_STOCK_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          machineWiseBeamStockFilterOptions: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case MACHINE_WISE_BEAM_STOCK_REPORT_FAILURE, MACHINE_WISE_BEAM_STOCK_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default machineWiseBeamStockReportReducer;
  